import dashboard from './dashboard';

// ==============================|| MENU ITEMS ||============================== //

const menuItems = dashboard;

export default menuItems;
